import { render, staticRenderFns } from "./foundAd.vue?vue&type=template&id=f68f2a08&scoped=true"
import script from "./foundAd.vue?vue&type=script&lang=js"
export * from "./foundAd.vue?vue&type=script&lang=js"
import style0 from "./foundAd.vue?vue&type=style&index=0&id=f68f2a08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68f2a08",
  null
  
)

export default component.exports